import produce from 'immer'

import { ERROR_LOG } from './types'

export const initialState = {
  loading: true,
  error: false,
  errorLogLoading: false,
  errorLogList: [],
  columns: [],
  pages: { totalPages: 0, currentPage: 0 },
  totalItems: 0,
  dataFilters: [],
  dataFiltersError: null
}

const reducer = (state = initialState, { type, payload }) => produce(state, draft => {
  switch (type) {
    case ERROR_LOG.GET:
      draft.errorLogLoading = true
      break
    case ERROR_LOG.SUCCESS: {
      const { items, fields, totalItems, totalPages, currentPage } = payload
      draft.loading = false
      draft.errorLogLoading = false
      draft.errorLogList = items
      draft.columns = fields
      draft.totalItems = totalItems
      draft.pages = { totalPages, currentPage }
    }
      break
    case ERROR_LOG.ERROR:
      draft.loading = false
      draft.errorLogLoading = false
      draft.error = payload
      break
    case ERROR_LOG.CLEAR:
      return initialState
    // FILTER
    case ERROR_LOG.SEND_FILTER:
      draft.loading = true
      break
    case ERROR_LOG.GET_FILTER_DATA:
      draft.filterLoading = true
      break
    case ERROR_LOG.FILTER_DATA_SUCCESS:
      draft.dataFilters = payload
      draft.filterLoading = false
      break
    case ERROR_LOG.FILTER_DATA_ERROR:
      draft.dataFiltersError = payload
      draft.filterLoading = false
      break
    case ERROR_LOG.FILTER_DATA_CLEAR:
      draft.dataFilters = []
      draft.dataFiltersError = null
      draft.filterLoading = false
      break
    default:
      return initialState
  }
})

export default reducer
